import { render, staticRenderFns } from "./TelephonePrefix.vue?vue&type=template&id=b63f6a24&"
import script from "./TelephonePrefix.vue?vue&type=script&lang=ts&"
export * from "./TelephonePrefix.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports